<script setup lang="ts">
import { ref } from 'vue';
import { Language } from '@xpos/icons-svg';
import LanguageDialog from '@/components/LanguageDialog.vue';

const $props = defineProps<{
  modelValue?: string;
  rootFormData?: any;
  languageKey: string;
  type?: string;
  row?: number;
  placeholder?: string;
  disabled?: boolean;
}>();
const $emit = defineEmits<{
  (event: 'change', value: string): void;
  (event: 'update', value: string): void;
  (event: 'input', value: string): void;
  (event: 'update:modelValue', value: string): void;
  (event: 'blur'): void;
}>();

const languageVisible = ref(false);
const value = ref($props.modelValue);
const onSave = (value: { [key: string]: string }) => {
  $props.rootFormData[$props.languageKey] = value;
};

const onChange = () => {
  $emit('change', value.value as string);
  $emit('input', value.value as string);
  $emit('update:modelValue', value.value as string);
};

const onBlur = () => {
  $emit('blur');
};
</script>

<template>
  <div class="w-full">
    <el-space :size="5" alignment="start" class="h-full language-warpper w-full">
      <el-input
        v-model="value"
        @change="onChange"
        @input="onChange"
        style="height: 100%; min-height: 100%"
        @blur="onBlur"
        :type="$props.type"
        :row="$props.row"
        :placeholder="$props.placeholder"
        :autosize="true"
        :disabled="$props.disabled"
      ></el-input>
      <el-button type="primary" class="shrink-0 w-[50px]" @click="languageVisible = true"
        ><el-icon size="20"><Language /></el-icon
      ></el-button>
    </el-space>
    <LanguageDialog
      v-model="languageVisible"
      :title="$props.modelValue"
      :config="$props.rootFormData[$props.languageKey]"
      @save="onSave"
      :modal="false"
    />
  </div>
</template>

<style lang="scss">
.language-warpper {
  .el-space__item {
    height: 100%;
    &:first-child {
      width: 100%;
    }
  }
  .el-textarea__inner {
    min-height: 50px !important;
  }
}
</style>
